import React from "react";

import "./style.css";

interface Props {
  bg?: any;
  margin?: string;
  padding?: string;
  height?: string;
  width?: string;
  flexGrow?: any;
  fontSize?: string;
  color?: string;
  mailAddress: string;
  text:string;
  fontWeight?:
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "bold"
    | "normal"
    | (number & {})
    | "bolder"
    | "lighter"
    | undefined;
}

const MailToButton: React.FC<Props> = ({
  bg,
  margin,
  padding,
  height,
  width,
  fontSize,
  flexGrow,
  color,
  fontWeight,
  mailAddress,
  text
}) => {
  let backgroundColor = "transparent";

  if (bg === "gray") {
    backgroundColor = "#ddd";
  }

  return (
    <a
      href={`#connectMe`}
    //   onClick={(event)=>{javascript:window.open(mailAddress, 'mail');event.preventDefault()}}
      className="atag-basic"
      rel="noreferrer"
      style={{
        backgroundColor,
        margin,
        color,
        padding,
        height,
        width,
        fontWeight,
        flexGrow,
        fontSize,
      }}
    >
      {text}
    </a>
  );
};

export default MailToButton;
